import { NavLink } from 'react-router-dom';
import type { AppMode } from '@bmkg/core';
import { StatusBadge, type StatusIcon } from './StatusBadge';
import { useDataSaver } from './use-data-saver';
import styles from './Header.module.css';

interface HeaderProps {
  mode: AppMode;
}

const navItems = [
  { to: '/', label: 'Beranda' },
  { to: '/lapor', label: 'Lapor' },
  { to: '/edukasi', label: 'Edukasi' },
  { to: '/panduan', label: 'Panduan' },
];

// Status siaga default shell (data status live datang dari CP04/CP10).
const siagaIcon: StatusIcon = 'perisai';

export function Header({ mode }: HeaderProps) {
  const modeLabel = mode === 'bmkg' ? 'Data BMKG' : 'Laporan warga';
  const dataSaver = useDataSaver();

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.logo} aria-hidden="true">
            J
          </span>
          <div>
            <p className={styles.title}>Jawa Tengah Tangguh</p>
            <p className={styles.mode}>{modeLabel}</p>
          </div>
        </div>
        <StatusBadge label="Siaga: Aman" icon={siagaIcon} level="aman" />
        <nav aria-label="Navigasi utama" className={styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                isActive ? `${styles.navItem} ${styles.navItemActive}` : styles.navItem
              }
            >
              {item.label}
            </NavLink>
          ))}
          <button
            type="button"
            className={styles.navItem}
            aria-pressed={dataSaver.active}
            data-testid="data-saver-toggle"
            onClick={dataSaver.toggle}
            title="Saat aktif: foto laporan tidak dimuat otomatis, tile peta lebih ringan"
          >
            {dataSaver.active ? 'Hemat data: aktif' : 'Hemat data'}
          </button>
        </nav>
      </div>
    </header>
  );
}
